module.exports = __webpack_public_path__ + "465f6cd3cfa3e518b7036e4d9307e0a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-7.png
// module id = 2955
// module chunks = 0